import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import CheckBoxOutlineBlankSharp from "@mui/icons-material/CheckBoxOutlineBlankSharp";
import CheckBoxSharp from "@mui/icons-material/CheckBoxSharp";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import type { Dispatch, ReactNode } from "react";

export interface ColorStatusFilterProps {
  label: string;
  options: Array<AutocompleteData>;
  value?: Array<AutocompleteData>;
  onChange: Dispatch<Array<AutocompleteData>>;
  formatOptionText?: (option: AutocompleteData) => ReactNode;
}

export const ColorSearchMultiSelect = ({
  label,
  options,
  value = [],
  onChange,
  formatOptionText = (option) => option.name,
}: ColorStatusFilterProps) => {
  return (
    <Autocomplete
      sx={{ "& .MuiInputBase-root": { borderRadius: "4px" } }}
      multiple
      fullWidth
      onChange={(_e, value) => onChange([...value])}
      options={options}
      value={value}
      disableCloseOnSelect
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={<CheckBoxOutlineBlankSharp fontSize="small" />}
            checkedIcon={<CheckBoxSharp fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {formatOptionText(option)}
        </li>
      )}
      renderInput={({ inputProps, ...params }) => (
        <TextField
          {...params}
          inputProps={{ ...inputProps, readOnly: true, style: { minWidth: 0 } }}
          label={label}
        />
      )}
    />
  );
};
